module.exports = __webpack_public_path__ + "img/customer-service.47f47a4e.png";